import { useAuth } from "@clerk/clerk-react";
import { useEffect, type ReactNode } from "react";
import { setAuthTokenGetter } from "@/lib/api/authToken";

/**
 * Registers Clerk `getToken` for `apiRequest`. Children render while Clerk loads so
 * pre-rendered public pages stay visible; host-only routes wait in `RequireHostAuth`.
 */
export function ClerkAuthBridge({ children }: { children: ReactNode }) {
  const { getToken, isLoaded } = useAuth();

  // Set during render (not in an effect) so the first signed-in fetch already has a token.
  if (isLoaded) setAuthTokenGetter(() => getToken());

  useEffect(() => () => setAuthTokenGetter(null), []);

  return children;
}
